import ApiClient from './ApiClient';

class ChatGroupAPI extends ApiClient {
  constructor() {
    super('chat_groups', { accountScoped: true });
  }
}

export default new ChatGroupAPI();
